<template>
	<div class="payResult">
		<van-row class="resultBar" v-if="this.result=='get_brand_wcpay_request:cancel'||this.result=='get_brand_wcpay_request:fail'">
			<van-col span="24" class="noPayPC"></van-col>
			<van-col span="24" class="noPayText">支付失败！</van-col>
			<van-col span="12" class="payBtn">
				<van-button round type="danger" class="solidBtn" @click="goPath('/paydetail')">去支付</van-button>
			</van-col>
			<van-col span="12" class="payBtn">
				<van-button round type="danger" class="hollowBtn" @click="goPath('/order')">返回列表</van-button>
			</van-col>
		</van-row>
		<van-row class="resultBar" v-if="this.result=='get_brand_wcpay_request:ok'">
			<van-col span="24" class="successPayPC"></van-col>
			<van-col span="24" class="successPayText">支付成功！</van-col>
			<van-col span="24" class="payBtn">
				<van-button round type="danger" class="hollowBtn" @click="goPath('/payment')">返回首页</van-button>
			</van-col>
		</van-row>
		<van-row class="resultBar" v-if="this.result=='get_brand_wcpay_request:querying'">
			<van-col span="24" class="noPayPC"></van-col>
			<van-col span="24" class="noPayText">支付查询中...{{seconds}}</van-col>
			<!-- <van-col span="12" class="payBtn">
	    <van-button round type="danger" class="solidBtn" @click="goPath('/paydetail')">去支付</van-button>
	  </van-col> -->
			<van-col span="24" class="payBtn">
				<van-button round type="danger" class="hollowBtn" @click="goPath('/order')">返回列表</van-button>
			</van-col>
		</van-row>
		<van-row class="resultBar" v-if="this.result=='get_brand_wcpay_request:exception'">
			<van-col span="24" class="noPayPC"></van-col>
			<van-col span="24" class="noPayText">支付异常,请在24小时内再次查询！</van-col>
			<!-- <van-col span="12" class="payBtn">
	    <van-button round type="danger" class="solidBtn" @click="goPath('/paydetail')">去支付</van-button>
	  </van-col> -->
			<van-col span="12" class="payBtn">
				<van-button round type="danger" class="hollowBtn" @click="goPath('/order')">返回列表</van-button>
			</van-col>
		</van-row>
		<!-- <van-row>
			<van-col span="24" class="noPayText">{{errors}}</van-col>
		</van-row> -->
		<van-popup class="tagBox" v-model="isTagShow" position="bottom" :style="{ height: '20%' }">
			<van-swipe :loop="false" :width="100" class="tagBar" :show-indicators="false">
				<van-swipe-item v-for="(item,index) in Taglist" :key="index" @click="TagChange(item)">{{item}}</van-swipe-item>
			</van-swipe>
		</van-popup>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	import {
		Dialog
	} from 'vant';
	import {
		reqRoomTaglist,
		reqAddressAdd,
		reqPFPayOrderAdd,
		reqPFStatus,
		reqPFSearch,
		reqPFClear,
		reqPFUpdate
	} from '../../api'
	export default {
		name: "payresult",
		data() {
			return {
				userId: '',
				result: '',
				roomId: '',
				TagValue: '',
				Taglist: [],
				isTagShow: false,
				payData: {},
				timer: '',
				// errors: '',
				seconds: ''
			}
		},
		created() {
			this.userId = this.$cookies.get('userInfo').userId			
			this.roomId = this.$route.query.roomId
			this.payData = this.$route.query.payData
			this.payTypes = this.$route.query.payTypes
			//直接绑定
			this.onTag()
			//判断是否浦发支付
			if (this.payTypes == 'pf') {
				if(this.$route.query.result=='get_brand_wcpay_request:ok'){
					this.updateStatus(JSON.parse(this.payData).order.id);
					this.result = 'get_brand_wcpay_request:querying';
				}
				this.init();
			} else{
				this.result = this.$route.query.result
				// this.onTag()
			}
		},
		methods: {
			init() {
				var second = 15;
				this.timer = setInterval(() => {
					second--;
					if (second) {
						this.seconds = second;
					} else {
						clearInterval(this.timer);
						this.seconds = '';
					}
				}, 1000);
				//调用浦发查询状态 
				this.orderSearch(JSON.parse(this.payData), 0);
			},
			//更新状态
			updateStatus(orderId){
				reqPFStatus({orderId:orderId}).then(res=>{
					console.log(res);
				})
			},
			//订单查询
			orderSearch(data, num) {
				var params = {
					roomId: data.order.roomId,
					tranOrdrNo: data.resp.tranOrdrNo,
					tranDate: data.resp.tranDate
				};
				reqPFSearch(params).then(res => {
					if (res.ordrSt == "00") {
						this.orderUpdate(data);
					} else {
						if (num < 5) {
							num++
							setTimeout(() => {
								this.orderSearch(data, num);
							}, 3000);
						} else {
							this.result = 'get_brand_wcpay_request:exception'
							clearInterval(this.timer);
						}

					}
				})
			},
			//订单更新
			orderUpdate(data) {
				//api/wxorder/micropay/update，参数：methodId，orderId，serviceType
				var params = {
					methodId: data.payMethodConfig.id,
					orderId: data.order.id,
					serviceType: data.order.serviceType,
					roomId:data.order.roomId
				};
				reqPFUpdate(params).then(res => {
					if (res.success) {
						clearInterval(this.timer);
						this.result = 'get_brand_wcpay_request:ok'
						// this.onTag()
					}else{
						this.result = 'get_brand_wcpay_request:exception'
					}
				})
			},
			/*
			 * 获取标签
			 * */
			onTag() {
				reqRoomTaglist().then(res => {
					if (res.success) {
						if (res.data.tags == '') {
							Toast.fail({
								message: '暂无数据！',
								className: 'apiLoading'
							});
						} else {
							//this.Taglist = res.data.tags.split(',');
							//this.isTagShow = true;
							this.TagChange("其他")
						}
					} else {
						Toast.fail({
							message: '系统错误，请联系管理员！',
							className: 'apiLoading'
						});
					}
				})
			},
			/*
			 * 选择标签
			 * */
			TagChange(tag) {
				//console.log(tag);
				this.TagValue = tag;
				//this.isTagShow = false;
				let data = {
					userId: this.userId,
					defaultFlag: 0,
					tag: this.TagValue,
					roomId: this.roomId
				}
				reqAddressAdd(data).then(res => {
					if (res.success) {
						// this.$router.push({
						// 	path: '/addressmanage',
						// 	name: 'addressmanage'
						// })
					} else {
						// Toast.fail({
						// 	message: res.msg,
						// 	className: 'apiLoading'
						// });
					}
				})
			},
			/*
			 * 去支付
			 * */
			goPath(path) {
				if (path == '/order' || path == '/payment') {
					this.$router.push({
						path: path,
						name: path.substring(1)
					})
				} else if (path == '/paydetail') {
					this.$router.push({
						path: path,
						name: path.substring(1),
						query: {
							roomId: this.roomId
						}
					})
				}
			}
		}
	}
</script>
<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .orange
    color #ff6d02
  .payResult
    padding-bottom 80px
    background #f9f9f9
    .resultBar
      margin 10px 0px
      background #ffffff
      text-align center
      .noPayPC,.successPayPC
        height 300px
        margin-top 80px
        background url("./images/noPay.png") no-repeat center
        background-size 50% auto
      .successPayPC
        background url("./images/success.png") no-repeat center
        background-size 50% auto
      .noPayText
        font-size 32px
        color #569dff
      .successPayText
        font-size 32px
        color #ff6d02
      .hollowBtn {
        background: transparent !important;
        color: #ff6d02;
        font-size: 0.373333rem;
        border: 0.026667rem solid #ff6d02;
      }
      .solidBtn {
        font-size: 0.373333rem;
        background: #ff6d02;
      }
      .solidBtn,.hollowBtn
        margin 100px 0px
        width 300px
        height 90px
    .tagBox
      margin 0px 5%
      width 90%
    .tagBar
      margin 40px 20px
      .van-swipe-item
        display inline-block
        background #ff6d02
        width 130px!important
        margin 20px 10px
        color #fff
        border-radius 50%
        text-align center
        font-size 28px
        height 30px!important
        padding 50px 0px
</style>


// WEBPACK FOOTER //
// src/pages/Order/payResult.vue